import type { RecipientProfileType } from "./forms";
import type { NetworkPayload } from "../../../composites";

export const API = {
  fetchRecipients: ({
    includeHidden = false,
  }: { includeHidden?: boolean } = {}): NetworkPayload => {
    const params = new URLSearchParams({ limit: "1000" });
    if (includeHidden) {
      params.set("include_hidden", "true");
    }
    return {
      url: `recipients/?${params.toString()}`,
      options: {
        method: "GET",
      },
    };
  },

  deleteRecipient: (recipientId: API.RecipientId): NetworkPayload => {
    return {
      url: `recipients/${recipientId}/`,
      options: {
        method: "DELETE",
        isJsonResponse: false,
      },
    };
  },

  createOrUpdateRecipientProfile: (
    { name, nickname, type }: RecipientProfileType,
    recipientId?: API.RecipientId,
  ): NetworkPayload => {
    return {
      url: `recipients/${recipientId ? `${recipientId}/` : ""}`,
      options: {
        method: recipientId ? "PUT" : "POST",
        payload: {
          name,
          nickname,
          type,
        },
      },
    };
  },

  createOrUpdateACHDestination: ({
    account_number,
    routing_number,
    account_type,
    account_purpose,
    recipient,
  }: API.CreateUpdateACHDestination.Request): NetworkPayload => {
    return {
      url: `ach_details/`,
      options: {
        method: "POST",
        payload: {
          account_number,
          routing_number,
          account_type,
          account_purpose,
          recipient,
        },
      },
    };
  },

  createWireDestination: ({
    account_number,
    routing_number,
    address,
    recipient,
  }: API.CreateUpdateWireDestination.Request): NetworkPayload => {
    return {
      url: `fedwire_destinations/`,
      options: {
        method: "POST",
        payload: {
          account_number,
          routing_number,
          address,
          recipient,
        },
      },
    };
  },

  updateWireDestination: ({
    account_number,
    routing_number,
    address,
    recipient,
    fedwireId,
  }: API.CreateUpdateWireDestination.Request & {
    fedwireId: API.FedwireDestinationId;
  }): NetworkPayload => {
    return {
      url: `fedwire_destinations/${fedwireId}/`,
      options: {
        method: "PUT",
        payload: {
          account_number,
          routing_number,
          address,
          recipient,
        },
      },
    };
  },

  createSwiftDestination: ({
    bic,
    account_identifier,
    metadata,
    recipient,
    address,
    branch_address,
    correspondent_bank_bic,
  }: API.CreateUpdateSwiftDestination.Request): NetworkPayload => {
    return {
      url: `swift_destinations/`,
      options: {
        method: "POST",
        payload: {
          bic,
          account_identifier,
          metadata,
          recipient,
          address,
          branch_address,
          correspondent_bank_bic,
        },
      },
    };
  },

  fetchSwiftAdditionalDetails: (bic: string): NetworkPayload => {
    return {
      url: `swift_destinations/bic/${bic}/`,
      options: {
        method: "GET",
      },
    };
  },

  fetchSwiftAdditionalFieldsByCountry: (
    countryCode: string,
  ): NetworkPayload => {
    return {
      url: `swift_destinations/additional_fields/${countryCode}/`,
      options: {
        method: "GET",
      },
    };
  },

  fetchRecipientAddressRenameFields: (country_code: string): NetworkPayload => {
    return {
      url: `swift_destinations/country/${country_code}/`,
      options: {
        method: "GET",
      },
    };
  },
};
